import React from 'react';
import Anime from 'react-anime';
import Balls from '../components/Balls';
import ScrollDown from '../components/ScrollDown';
export default ({ isActive, goToNextSlide }) => {
  const fadeInTitle = {
    opacity: [
      { value: 0, duration: 0, },
      { value: 1, duration: 1000, easing: 'linear', delay: 2250 }
    ]
  };
  const message = `Clinical trials are conducted over four phases, and are the gold standard of approving medicines around the world.`;

  const handleNextSlide = () => goToNextSlide();
  return (
    <div className="component">
      <div className="text-container text-container--higher">
        <p className="secondary-large centered copy">{message}</p>
      </div>
      {isActive && (<Balls />)}
      {isActive && (
        <Anime {...fadeInTitle}>
          <ScrollDown text={'Now Entering Phase 1'} isWhite="false" onClickNextSlide={handleNextSlide} />
        </Anime>
      )}
    </div>
  );
};